const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, options);
  const contentType = res.headers.get('Content-Type') || '';
  if (!contentType.includes('application/json')) {
    throw Object.assign(
      new Error(res.ok ? 'API not reachable (got HTML instead of JSON)' : `HTTP ${res.status}`),
      { status: res.status }
    );
  }
  const json = await res.json().catch(() => { throw Object.assign(new Error('Invalid JSON'), { status: res.status }); });
  if (!res.ok) {
    throw Object.assign(new Error(json.error || 'Request failed'), { status: res.status, data: json });
  }
  return json;
}

export async function apiGet(path) {
  return apiFetch(path, { method: 'GET' });
}

export async function adminGet(path) {
  return apiFetch(path, { method: 'GET', credentials: 'include' });
}

export async function adminPost(path, body) {
  return apiFetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function adminUpload(path, formData) {
  return apiFetch(path, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
}
